import {createContext} from 'react';
import {noop} from '@priority-software/priority-style-react';
import {TEmailStateType} from '../../../EmailEditor/reducer/types';

const defaultValue = {
    escClosable: true,
    handleEscClosable: noop,
    session: '',
    closeCurrentAutomation: noop,
    handleSaveNewEmailTemplate: noop,
    newEmailTemplate: null
};

export type RuleDialogContextModel = {
    escClosable: boolean;
    session: string;
    handleEscClosable: (flag: boolean) => void;
    closeCurrentAutomation: () => void;
    handleSaveNewEmailTemplate: (states: TEmailStateType) => void;
    newEmailTemplate: TEmailStateType | null;
};
export const RuleDialogContext = createContext<RuleDialogContextModel>(defaultValue);
